import { render, staticRenderFns } from "./CollapsibleContentSectionModule.vue?vue&type=template&id=14fc663e&"
import script from "./CollapsibleContentSectionModule.vue?vue&type=script&lang=js&"
export * from "./CollapsibleContentSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports